import totalLogo from 'assets/logo_totalenergies.png';
import clsx from 'clsx';

import styles from './TotalLogo.module.scss';

const TotalLogo = ({ className }: { className?: string }) => (
  <div className={clsx(styles.logoWrapper, className)}>
    <img className={styles.totalLogo} alt="TotalEnergies logo" src={totalLogo} />
  </div>
);

export default TotalLogo;
